<div (inViewportAction)="onIntersection($event)" [inViewportOptions]="{ threshold: [0] }" class="container-fluid rodape"
     inViewport>
    <div class="container">
        <div class="p-grid p-mt-2 nested-grid text-color-white">
            <div class="p-col-12 p-lg-3 p-p-2">
                <div class="p-grid p-ai-center p-nogutter p-text-center p-p-3 border-all border-white" style="height: 100%;">
                    <div class="p-col-12">
                        <div class="imagem-acessibilidade">
                            <fa-icon [icon]="faDeaf" class="fa-3x"></fa-icon>
                            <fa-icon [icon]="faEyeSlash" class="fa-3x"></fa-icon>
                        </div>
                    </div>
                    <div class="p-col-12 font-size-2 p-py-3">
                        Este site é preparado para pessoas com deficiências visual e auditiva
                    </div>
                    <div class="p-col-12 p-py-2">
                        <app-botoes-acessibilidade [classe]="'rodape'"></app-botoes-acessibilidade>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-lg-9 p-p-2">
                <div class="p-grid" style="margin: -0.5rem;">
                    <div class="p-col-12 p-lg-8">
                        <div class="p-grid p-nogutter p-text-center p-p-3 border-all border-white" style="height: 100%;">
                            <div class="p-col-12">
                                <div class="acesso-direto p-mb-2 font-size-1">
                                    Acessos diretos
                                </div>
                                <div class="p-p-2 font-size-4">
                                    <a href="https://www.trf5.jus.br/" target="_blank" class="mr-2 font-weight-bold text-color-white"
                                        pTooltip="Acessar o Portal do TRF5" tooltipPosition="bottom" rel="noopener">TRF5</a>
                                    <a href="http://www.jfal.jus.br/" target="_blank" class="mr-2 font-weight-bold text-color-white"
                                        pTooltip="Acessar o Portal da Seção Judiciária de Alagoas" tooltipPosition="bottom" rel="noopener">JFAL</a>
                                    <a href="http://www.jfce.jus.br/" target="_blank" class="mr-2 font-weight-bold text-color-white"
                                        pTooltip="Acessar o Portal da Seção Judiciária do Ceará" tooltipPosition="bottom" rel="noopener">JFCE</a>
                                    <a href="http://www.jfpb.jus.br/" target="_blank" class="mr-2 font-weight-bold text-color-white"
                                        pTooltip="Acessar o Portal da Seção Judiciária da Paraiba" tooltipPosition="bottom" rel="noopener">JFPB</a>
                                    <a href="https://www.jfpe.jus.br/" target="_blank" class="mr-2 font-weight-bold text-color-white"
                                        pTooltip="Acessar o Portal da Seção Judiciária de Pernambuco" tooltipPosition="bottom" rel="noopener">JFPE</a>
                                    <a href="http://www.jfse.jus.br/" target="_blank" class="font-weight-bold text-color-white"
                                        pTooltip="Acessar o Portal da Seção Judiciária em Sergipe" tooltipPosition="bottom" rel="noopener">JFSE</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-lg-4 p-p-2">
                        <a routerLink="sei" class="p-text-bold text-color-white font-size-6 p-grid p-ai-center p-nogutter p-text-center p-p-3 border-all border-white"
                            pTooltip="Acessar página do SEI" tooltipPosition="bottom" style="height: 100%;">
                            <div class="p-col-12">
                                sei!
                            </div>
                        </a>
                    </div>

                    <div class="p-col-12 p-lg-6 p-p-2">
                        <div class="p-grid p-ai-center p-nogutter p-text-center p-p-3 border-all border-white" style="height: 100%;">
                            <div class="p-col-12">
                                <div class="sistemas p-mb-3 font-size-1">
                                    Sistemas Administrativos e Judiciais
                                </div>
                                <div class="link-sistemas p-p-3 font-size-4">
                                    <ul>
                                        <li>
                                            <a href="https://intranet.jfrn.jus.br" target="_blank"
                                                pTooltip="Acessar a Intranet" tooltipPosition="bottom" rel="noopener">INTRANET</a>
                                        </li>
                                        <li>
                                            <a href="https://malotedigital.cjf.jus.br/malotedigital/login.jsf" target="_blank"
                                                pTooltip="Acessar o Malote Digital" tooltipPosition="bottom" rel="noopener">MALOTE DIGITAL</a>
                                        </li>
                                        <li>
                                            <a href="https://ccheque.jfrn.jus.br/portal_servidor/ccheque/views/login.php" target="_blank"
                                                pTooltip="Acessar o SARH" tooltipPosition="bottom" rel="noopener">SARH</a>
                                        </li>
                                        <li>
                                            <a href="https://seeu.pje.jus.br/seeu/" target="_blank"
                                                pTooltip="Acessar o SEEU" tooltipPosition="bottom" rel="noopener">SEEU</a>
                                        </li>
                                        <li>
                                            <a href="https://simpent.jfrn.jus.br/" target="_blank"
                                                pTooltip="Acessar o SIMPENT" tooltipPosition="bottom" rel="noopener">SIMPENT</a>
                                        </li>
                                        <li>
                                            <a href="https://webmail.jfrn.jus.br/" target="_blank"
                                                pTooltip="Acessar o Webmail" tooltipPosition="bottom" rel="noopener">WEBMAIL</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12 p-lg-3 p-p-2">
                        <a href="https://juliapesquisa.trf5.jus.br/julia-pesquisa/pesquisa#consulta" target="_blank" class="p-text-bold text-color-white font-size-2 p-grid p-ai-center p-nogutter p-text-center p-p-3 border-all border-white"
                            pTooltip="Acessar página do JULIA - Pesquisa Inteligente" tooltipPosition="bottom" style="height: 100%;">
                            <div class="p-col-12">
                                JULIA <br> PESQUISA INTELIGENTE
                            </div>
                        </a>
                    </div>
                    <div class="p-col-12 p-lg-3 p-p-2">
                        <a href="https://portalbi.trf5.jus.br/portal-bi/" target="_blank" class="p-grid p-ai-center p-nogutter p-text-center p-p-3 font-size-2 border-all border-white bg-white"
                            pTooltip="Acessar portal Business Intelligence" tooltipPosition="bottom" style="height: 100%;" rel="noopener">
                            <div class="p-col-12">
                                PORTAL BUSINESS INTELLIGENCE
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="p-col-12 p-lg-6 p-p-2">
                <a routerLink="institucional/lgpd" target="_self" class="p-grid p-ai-center p-nogutter p-text-center p-p-3 font-size-2 p-text-uppercase border-all border-white bg-white"
                    pTooltip="Acessar a LGPD - Lei Geral de Proteção de Dados Pessoais" tooltipPosition="bottom" style="height: 100%;" rel="noopener">
                    <div class="p-col-12">
                        LGPD - Lei Geral de Proteção de Dados Pessoais
                    </div>
                </a>
            </div>

            <div class="p-col-12 p-lg-6 p-p-2">
                <a href="{{pathFormularioSIC.caminho}}" class="text-color-white p-grid p-ai-center p-nogutter p-text-center p-p-3 p-text-uppercase font-size-2 border-all border-white"
                    pTooltip="Acessar o SIC - Serviços de Informação ao Cidadão" tooltipPosition="bottom" target="_blank" style="height: 100%;" rel="noopener">
                    <div class="p-col-12">
                        SIC - Serviços de Informação ao Cidadão/Ouvidoria
                    </div>
                </a>
            </div>

          <div class="p-col-12 p-lg-9 p-p-2">
            <div class="p-grid p-nogutter" style="height: 100%;" class="rodape-tabview">
              <div class="p-col-12">
                <p-tabs value="0">
                  <p-tablist>
                    <p-tab value="0">Natal</p-tab>
                    <p-tab value="1">Assu</p-tab>
                    <p-tab value="2">Caíco</p-tab>
                    <p-tab value="3">Ceará-Mirim</p-tab>
                    <p-tab value="4">Mossoró</p-tab>
                    <p-tab value="5">Pau dos Ferros</p-tab>
                  </p-tablist>

                  <p-tabpanels>
                    <p-tabpanel value="0">
                      <div class="p-d-flex p-jc-between">
                          <div>
                              Rua Dr. Lauro Pinto, 245, Lagoa Nova <br>
                              Natal - RN CEP: 59064-250 <br>
                              Atendimento: Das 08:00 às 14:00 sem interrupção
                          </div>

                          <div class="p-text-right">
                              <fa-icon [icon]="faPhoneSquare"></fa-icon><b>Telefone:</b> (84) 4005-7400<br>
                          </div>
                      </div>
                    </p-tabpanel>
                    <p-tabpanel value="1">
                        <div class="p-d-flex p-jc-between">
                            <div>
                                Rua Doutor Luiz Carlos, 3048, Dom Elizeu <br>
                                Assu - RN CEP: 59650-000 <br>
                                Atendimento: Das 08:00 às 14:00 sem interrupção
                            </div>

                            <div class="p-text-right">
                                <fa-icon [icon]="faPhoneSquare"></fa-icon><b>Telefone(s):</b> (84) 3331-2704 / (84) 99609-9647
                            </div>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="2">
                      <div class="p-d-flex p-jc-between">
                          <div>
                              Avenida Dom José Adelino Dantas, s/nº, Complexo Judiciário Maynard <br>
                              Caicó - RN CEP: 59300-000 <br>
                              Atendimento: Das 08:00 às 14:00 sem interrupção
                          </div>

                          <div class="p-text-right">
                              <fa-icon [icon]="faPhoneSquare"></fa-icon><b>Telefone(s):</b> (84) 3421-2295 / (84) 99144-2047 <br>
                          </div>
                      </div>
                    </p-tabpanel>
                    <p-tabpanel value="3">
                      <div class="p-d-flex p-jc-between">
                        <div>
                          Avenida Luiz Lopes Varela, 1123, Conj. Luiz Lopes Varela <br>
                          Ceará-Mirim - RN CEP: 59570-000 <br>
                          Atendimento: Das 08:00 às 17:00 sem interrupção
                        </div>

                        <div class="p-text-right">
                          <fa-icon [icon]="faPhoneSquare"></fa-icon><b>Telefone(s):</b>(84) 98101-4355
                        </div>
                      </div>
                    </p-tabpanel>
                    <p-tabpanel value="4">
                      <div class="p-d-flex p-jc-between">
                          <div>
                              Rua Jorge Coelho de Andrade, s/nº, Presidente Costa e Silva <br>
                              Mossoró - RN CEP: 59625-400 <br>
                              Atendimento: Das 08:00 às 14:00 sem interrupção
                          </div>

                          <div class="p-text-right">
                              <fa-icon [icon]="faPhoneSquare"></fa-icon><b>Telefone(s):</b>
                              (84) 3422-5882 (8ª Vara) <br>
                              (84) 3422-5856 (10ª vara)<br>
                              (84) 99609-9648 (13ª vara) <br>
                          </div>
                      </div>
                    </p-tabpanel>
                    <p-tabpanel value="5">
                        <div class="p-d-flex p-jc-between">
                            <div>
                                Rua Djalma de Freitas, s/nº, Princesinha do Oeste <br>
                                Pau dos Ferros - RN CEP: 59900-000 <br>
                                Atendimento: Das 08:00 às 14:00 sem interrupção
                            </div>

                            <div class="p-text-right">
                                <fa-icon [icon]="faPhoneSquare"></fa-icon><b>Telefone(s):</b> (84) 3351-3236 / (84) 99117-8468
                            </div>
                        </div>
                    </p-tabpanel>
                  </p-tabpanels>
                </p-tabs>
              </div>
            </div>
          </div>

            <div class="p-col-12 p-lg-3 p-p-2">
                <div class="p-grid p-nogutter p-text-center">
                    <div class="p-col-12">
                        <a href="https://www.facebook.com/justicafederalnorn" class="mr-1 text-color-white" aria-label="Acessar facebook da JFRN"
                            pTooltip="Acessar Facebook da JFRN" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faFacebook" class="fa-2x"></fa-icon>
                        </a>
                        <a href="https://www.instagram.com/jf_rn/" class="mr-1 text-color-white" aria-label="Acessar instagram da JFRN"
                            pTooltip="Acessar Instagram da JFRN" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faInstagram" class="fa-2x"></fa-icon>
                        </a>
                        <a href="https://twitter.com/jf_rn" class="mr-1 text-color-white" aria-label="Acessar twitter da JFRN"
                            pTooltip="Acessar Twitter da JFRN" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faTwitter" class="fa-2x"></fa-icon>
                        </a>
                        <a href="https://www.youtube.com/channel/UC_CId6w-nfDYj-SvaJZUoUw" class="mr-1 text-color-white" aria-label="Acessar youtube da JFRN"
                            pTooltip="Acessar Youtube da JFRN" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faYoutube" class="fa-2x"></fa-icon>
                        </a>
                        <a href="https://anchor.fm/jfrn" class="mr-1 text-color-white" aria-label="Acessar JFRNCast"
                           pTooltip="Acessar JFRNCast" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faMicrophoneAlt" class="fa-2x"></fa-icon>
                        </a>
                        <a href="https://tiktok.com/@jf_rn" class="mr-1 text-color-white" aria-label="Acessar TikTok da JFRN"
                           pTooltip="Acessar TikTok da JFRN" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faTiktok" class="fa-2x"></fa-icon>
                        </a>
                        <a href="https://linkedin.com/company/jfrn" class="text-color-white" aria-label="Acessar LinkedIn da JFRN"
                           pTooltip="Acessar LinkedIn da JFRN" tooltipPosition="bottom" target="_blank" rel="noopener">
                            <fa-icon [icon]="faLinkedin" class="fa-2x"></fa-icon>
                        </a>

                        <div class="p-col-12">
                            <img src="assets/images/jfrn-branco.svg" alt="Logotipo da Justiça Federal do Rio Grande do Norte" width="100px">

                            <button (click)="mostrarMapa()" class="botao-mapa" pTooltip="Acessar mapa do site"
                                tooltipPosition="bottom" accesskey="m">MAPA DO SITE</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
